import { jsx as _jsx } from "react/jsx-runtime";
import { ViewPaymentRequest } from '@src/components/Employee/PaymentRequests/ViewPaymentRequest';
import { useParams } from 'react-router-dom';
export const PaymentRequestPage = () => {
    const { id = '' } = useParams();
    return _jsx(ViewPaymentRequest, { id: parseInt(id, 10) });
};
